module.exports = "<div class=\"perfil\">\n  <!-- views do perfil serão injetadas aqui -->\n  <div ui-view class=\"container\"></div>\n</div>\n"